// @flow

import * as CursorSpinner        from 'fg-frontend/src/components/CursorSpinner';
import { eshopUserToolsRefresh } from './eshopUserToolsRefresh';
import $                         from 'jquery';

/**
 * product tools event handlers
 */
// $FlowFixMe
export default (props, e) => {
	const { ajaxHref, activeClass } = props;

	const self = e.target;

	e.preventDefault();

	CursorSpinner.pushToQueue('eshopUserToolsHandle');

	$.post(ajaxHref, (data) => {
		if ( data.ok ) {
			CursorSpinner.removeFromQueue('eshopUserToolsHandle');

			eshopUserToolsRefresh();

			if ( self.classList.contains(activeClass) ) {
				self.href = self.href.replace('removeItem', 'addItem');
				self.setAttribute('data-ajax-href', ajaxHref.replace('removeItemJson', 'addItemJson'));
			} else {
				self.href = self.href.replace('addItem', 'removeItem');
				self.setAttribute('data-ajax-href', ajaxHref.replace('addItemJson', 'removeItemJson'));
			}
			self.classList.toggle(activeClass);
		}
	});
};



// WEBPACK FOOTER //
// ./fe/web-majetek/src/js/webActions/eshopUserToolsHandle.js